import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { msalInstance } from './config/authConfig';
import { EventType, AuthenticationResult } from '@azure/msal-browser';

// Log environment details
const envMode = import.meta.env.MODE;
console.log(`%c[Environment] Active Mode: ${envMode.toUpperCase()}`, 'color: #00bcd4; font-weight: bold;');
console.log(`%c[Environment] Configuration Source: .env.${envMode}`, 'color: #00bcd4;');
console.log('[Environment] API Base URL:', import.meta.env.VITE_API_BASE_URL);

const container = document.getElementById('root');
const root = createRoot(container!);

// Force re-login on redeploy or server restart
const currentBuildId = __APP_BUILD_ID__;
const lastBuildId = localStorage.getItem('MIGRATION_APP_BUILD_ID');

if (lastBuildId && lastBuildId !== currentBuildId) {
  console.log('%c[Auth] New deployment/restart detected. Clearing session cache.', 'color: #ff9800; font-weight: bold;');
  // Clear MSAL persistent cache
  Object.keys(localStorage).forEach((key) => {
    if (key.includes('msal.') || key.includes('login.microsoftonline.com')) {
      localStorage.removeItem(key);
    }
  });
  sessionStorage.clear();
}
localStorage.setItem('MIGRATION_APP_BUILD_ID', currentBuildId);

// Ensure we set the active account on successful login/token events
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
    const result = event.payload as AuthenticationResult | null;
    if (result && result.account) {
      msalInstance.setActiveAccount(result.account);
    }
  }
});

msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then((result) => {
    if (result && result.account) {
      msalInstance.setActiveAccount(result.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (!msalInstance.getActiveAccount() && accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }
  })
  .catch((err) => {
    // Handle error
    console.error(err);
  })
  .finally(() => {
    // Render only after redirect handling to avoid loops
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });